import { userRoutes } from 'modules/user/routes/constants';

export const ordersRoutes = {
  root: `${userRoutes.root}/orders`,
};
